import { render, staticRenderFns } from "./CreateCustomerModal.vue?vue&type=template&id=5f8568c0&scoped=true"
import script from "./CreateCustomerModal.vue?vue&type=script&lang=js"
export * from "./CreateCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomerModal.vue?vue&type=style&index=0&id=5f8568c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8568c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8568c0')) {
      api.createRecord('5f8568c0', component.options)
    } else {
      api.reload('5f8568c0', component.options)
    }
    module.hot.accept("./CreateCustomerModal.vue?vue&type=template&id=5f8568c0&scoped=true", function () {
      api.rerender('5f8568c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/customers/components/modal/CreateCustomerModal.vue"
export default component.exports